<script>

import HandlesFilters from "../../Mixins/HandlesFilters.js";

export default {

    name: 'DetailDataHandler',

    mixins: [HandlesFilters],

    props: ['prefix', 'start-date-segment', 'los-segment', 'companion-segment'],

    data() {
        return {
            hasInitialized: false,
            detailUrl: null,
            startDate: null,
            lengthOfStay: null,
            companionString: null,
        }
    },

    created() {

        this.startDate = this.startDateSegment === '' ? null : this.startDateSegment;
        this.lengthOfStay = this.losSegment === '' ? null : this.losSegment;
        this.companionString = this.companionSegment === '' ? null : this.companionSegment;
    },

    mounted() {

        this.buildAndGet();

        this.hasInitialized = true;

        this.Bus.on('companions-change', (data) => {

            this.companionString = data;

            this.buildAndGet();
        });

        this.Bus.on('calendar-change', (data) => {

            this.startDate = data.startDate?.dateFormatted ?? null;
            this.lengthOfStay = data.lengthOfStay ?? null;

            this.buildAndGet();
        });

        this.Bus.on('open-relevant-popup', (reference) => {

            if (! this.lengthOfStay) {
                this.Bus.emit('open-popup', 'arrival');
            } else {//} if (! this.companionString) {
                this.Bus.emit('open-popup', 'companions');
            }
        });

        this.Bus.on('popup-handle-apply', (reference) => {
            if (reference === 'arrival' && ! this.companionString) {
                this.Bus.emit('open-popup', 'companions');
            }
        });

        this.Bus.on('popup-handle-apply', (reference) => {
            if (reference === 'companions' && ! this.lengthOfStay) {
                this.Bus.emit('open-popup', 'arrival');
            }
        });

    },

    methods: {

        buildAndGet() {
            this.buildDetailUrl();

            if (! this.hasInitialized || this.lengthOfStay || this.startDate === null || (this.startDate && this.lengthOfStay === null)) {
                this.getData();
            }

            history.pushState(null, null, this.detailUrl);
        },

        getData() {

            // console.log('================================================= getData url:');
            // console.log(this.detailUrl);
            // console.log('///getData url:');

            this.Bus.emit('show-loader', 'price-section');
            this.Bus.emit('show-loader', 'grid-calendar-filters');
            this.Bus.emit('show-loader', 'grid-calendar-price');

            axios.post(this.detailUrl)
                .then(response => {

                    if (response.data.sections['price-information']) {
                        this.Bus.emit('render-view', {
                            reference: 'price-information',
                            content: response.data.sections['price-information'],
                        });
                    }

                    if (response.data.sections['price-section']) {
                        this.Bus.emit('render-view', {
                            reference: 'price-section',
                            content: response.data.sections['price-section'],
                        });
                    }

                    if (response.data.sections['grid-calendar-filters']) {
                        this.Bus.emit('render-view', {
                            reference: 'grid-calendar-filters',
                            content: response.data.sections['grid-calendar-filters'],
                        });
                    }

                    if (response.data.sections['grid-calendar-price']) {
                        this.Bus.emit('render-view', {
                            reference: 'grid-calendar-price',
                            content: response.data.sections['grid-calendar-price'],
                        });
                    }

                    this.Bus.emit('hide-loader', 'price-section');
                    this.Bus.emit('hide-loader', 'grid-calendar-filters');
                    this.Bus.emit('hide-loader', 'grid-calendar-price');
                })
                .catch(error => {

                    this.Bus.emit('hide-loader', 'price-section');
                    this.Bus.emit('hide-loader', 'grid-calendar-filters');
                    this.Bus.emit('hide-loader', 'grid-calendar-price');

                    console.log('ERROR:');
                    console.log(error);

                });
        },

        buildDetailUrl() {
            let detailUrlSegments = '';

            if (this.startDate) {
                detailUrlSegments += '/' + this.startDate;

                if (this.lengthOfStay) {
                    detailUrlSegments += '/' + this.lengthOfStay
                }
            }

            if (this.companionString) {
                detailUrlSegments += '/' + this.companionString
            }

            let queryString = '';

            Array.from(new URLSearchParams(window.location.search))
                .forEach((key) => (queryString.length === 0)
                    ? queryString += `?${key[0]}=${key[1]}`
                    : queryString += `&${key[0]}=${key[1]}`
                )
            ;

            this.detailUrl = this.prefix + detailUrlSegments + queryString;
        },
    },

    render() {}
}

</script>

